(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neobean-reviews-style"]) return;
  try {
    
  (() => {
    const dialog = document.querySelector('[data-neobean-review-dialog]');
    if (!dialog) return;
    let opener;
    dialog.querySelector('[data-review-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
    const prepareReviews = () => document.querySelectorAll('.jdgm-carousel-item').forEach((card) => {
      const body = card.querySelector('.jdgm-carousel-item__review-body');
      const content = card.querySelector('.jdgm-carousel-item__review-content');
      if (!body || !content || content.querySelector('.nb-review-read-more')) return;
      body.removeAttribute('tabindex');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'nb-review-read-more';
      button.textContent = dialog.dataset.readMore;
      button.setAttribute('aria-haspopup', 'dialog');
      content.append(button);
    });
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.nb-review-read-more');
      if (!button) return;
      const card = button.closest('.jdgm-carousel-item');
      const body = card?.querySelector('.jdgm-carousel-item__review-body');
      if (!body) return;
        event.preventDefault();
        event.stopPropagation();
        opener = button;
        dialog.querySelector('[data-review-title]').textContent = card.querySelector('.jdgm-carousel-item__review-title')?.textContent.trim() || dialog.dataset.readMore;
        dialog.querySelector('[data-review-author]').textContent = card.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim() || '';
        dialog.querySelector('[data-review-body]').textContent = body.innerText;
        const product = card.querySelector('.jdgm-carousel-item__product');
        const link = dialog.querySelector('[data-review-product]');
        link.hidden = !product;
        if (product) link.href = product.href;
        dialog.showModal();
      }, true);
    prepareReviews();
    new MutationObserver(prepareReviews).observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
